<template>
    <v-main>
        <head>
            <title>My Products - Foraje</title>
            <meta name="description" content="A list of all of your products">
        </head>
        <v-dialog v-model="productquickcreatedialog" max-width="750px" persistent>
          <div v-if="simplestquickcreate">
            <v-card>
              <v-card-title style="justify-content: center">
                <span class="headline">Quick Create a Product</span>
              </v-card-title>
              <v-card-text>
                <form @submit.prevent="QuickCreateProduct">
                  <v-container>
                    <v-row >
                      <v-col cols="12">
                        <v-text-field
                          name="newproductname"
                          label="Name"
                          hint="Name of the product"
                          required
                          id="newproductname"
                          v-model="newproduct.name"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field
                          name="newprice"
                          label="Product Price*"
                          hint="4.99, 125.00, etc. If left blank, will default to 0.00, or Free"
                          id="newprice"
                          required
                          v-model="newproduct.price"
                          prefix="$"
                          min="0"
                          step=".01"
                          type="number"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field
                          name="newunits"
                          label="Product Units*"
                          hint="How many units are you selling for the selected price? ie. per lb, per 100 seeds, per 10 kg, each etc."
                          id="newunits"
                          required
                          v-model="newproduct.price_units"
                          prefix="per"
                        ></v-text-field>
                      </v-col>
                    <v-col cols="12">
                      <v-text-field
                        name="newinventory"
                        label="Inventory"
                        hint="How many do you have in stock? If left blank, will default to '0', which we will assume means it's out of stock."
                        id="newinventory"
                        v-model="newproduct.inventory"
                        min="0"
                        max="1000000000"
                        type="number"
                        default="0"
                      ></v-text-field>
                    </v-col>
                      <v-col cols="12">
                        <v-file-input
                          label="Product Images"
                          hint="Any images you want to upload of this product."
                          prepend-icon="mdi-camera"
                          v-model="newproduct_images"
                          multiple
                          accept="image/*"
                        >
                          <template v-slot:selection="{ text }">
                            <v-chip
                              small
                              label
                              color="primary"
                            >
                              {{ text }}
                            </v-chip>
                          </template>
                        </v-file-input>
                      </v-col>
                    <v-col cols="12" style="text-align: end">
                      <v-btn @click="CancelQuickCreateProductDialog" class="ma-2">
                        Cancel
                      </v-btn>
                      <v-btn type="submit" :loading="productcreateloading" color="primary" class="ma-2">
                        Submit
                        <span slot="loader" class="custom-loader">
                        <v-progress-circular indeterminate color="green"></v-progress-circular>
                       </span>
                      </v-btn>
                    </v-col>
                    </v-row>
                  </v-container>
                </form>

              </v-card-text>
            </v-card>

          </div>
          <div v-else>
            <v-card>
                <v-alert dismissible color="secondary" icon="warning" v-model="nocropalert"
                         transition="scale-transition">You don't have any crops created yet, so just
                  select a variety for now, and we'll create a basic crop for you.</v-alert>
                <v-card-title>
                    Quick Create a Product
                </v-card-title>
                <v-card-text>
                    <form @submit.prevent="QuickCreateProduct">
                        <v-container v-if="arecropsorvarietiesloading">
                        <v-row v-if="arecropsorvarietiesloading">
                            <v-col cols="12" class="text-center pa-2">
                                <v-progress-circular
                                        :size="100"
                                        :width="7"
                                        color="primary"
                                        indeterminate
                                ></v-progress-circular>
                            </v-col>
                        </v-row>
                        </v-container>
                        <v-container v-else>
                        <v-row >
                            <v-col class="pa-2" cols="12" sm="10" v-if="preexistingcrop && cropitems.length">
                                        <v-autocomplete
                                                name="crops"
                                                label="Crop*"
                                                id="crops"
                                                v-model="newproduct.crop"
                                                :items="cropitems"
                                                item-text="name"
                                                return-object
                                                hint="What Crop does this Product come from?"
                                                :required="preexistingcrop"
                                                @input="GetAvailableVarietyComponentsFromCrop"
                                        >
                                        </v-autocomplete>
                                <v-btn @click="GetAllVarieties" mt-4>
                                    Don't have a crop created yet? Click here to simply select a Variety instead.
                                </v-btn>
                            </v-col>

                            <v-col class="pa-2" cols="12" sm="10" v-else>
                                    <v-autocomplete
                                            name="variety"
                                            label="Variety"
                                            id="variety"
                                            v-model="selectedvariety"
                                            :items="varietyitems"
                                            item-text="name"
                                            item-value="id"
                                            return-object
                                            hint="What Variety/Cultivar is it?"
                                            :required="!preexistingcrop"
                                            @input="GetAvailableVarietyComponentsFromVariety"
                                    >
                                    </v-autocomplete>
                                <v-btn v-if="cropitems.length && cropshavebeenfetched" @click="SwitchBackToCrop">
                                    Want to select an existing crop instead? Click here to select one.
                                </v-btn>
                            </v-col>

                            <v-col cols="12" class="text-center pa-2" v-if="arevarietycomponentsloading">
                                <v-progress-circular
                                        :size="100"
                                        :width="7"
                                        color="primary"
                                        indeterminate
                                ></v-progress-circular>
                            </v-col>
                            <v-col class="pa-2" cols="12" sm="10" v-if="availablevarietycomponents && availablevarietycomponents.length">

                                        <v-autocomplete
                                                name="components"
                                                label="Product Type*"
                                                id="components"
                                                v-model="newproduct.component"
                                                :items="availablevarietycomponents"
                                                item-text="name"
                                                return-object
                                                hint="What kind of thing is this Product?"
                                                required
                                        >
                                        </v-autocomplete>

                            </v-col>
                        </v-row>
                        <v-row >
                            <v-col cols="12">
                                <v-text-field
                                        name="newproductname"
                                        label="Name"
                                        hint="Name of the product"
                                        id="newproductname"
                                        v-model="newproduct.name"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row >
                            <v-col cols="12">
                                <v-text-field
                                        name="newprice"
                                        label="Product Price*"
                                        hint="4.99, 125.00, etc."
                                        id="newprice"
                                        required
                                        v-model="newproduct.price"
                                        prefix="$"
                                        min="0"
                                        step=".01"
                                        type="number"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row >
                            <v-col cols="12">
                                <v-text-field
                                        name="newunits"
                                        label="Product Units*"
                                        hint="How many units are you selling for the selected price? ie. per lb, per 100 seeds, per 10 kg, each etc."
                                        id="newunits"
                                        required
                                        v-model="newproduct.price_units"
                                        prefix="per"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-col cols="12">
                            <v-text-field
                                    name="newinventory"
                                    label="Inventory"
                                    hint="How many do you have in stock?"
                                    id="newinventory"
                                    v-model="newproduct.inventory"
                                    min="0"
                                    max="1000000000"
                                    type="number"
                                    default="0"
                            ></v-text-field>
                        </v-col>
                          <v-col cols="12">
                            <v-file-input
                              label="Product Image"
                              hint="Any images you want to upload of this product."
                              filled
                              prepend-icon="mdi-camera"
                              v-model="newproduct_images"
                              multiple
                            >
                              <template v-slot:selection="{ text }">
                                <v-chip
                                  small
                                  label
                                  color="primary"
                                >
                                  {{ text }}
                                </v-chip>
                              </template>
                            </v-file-input>
                          </v-col>
                        <v-col cols="4" offset="5">
                            <v-btn @click="CancelQuickCreateProductDialog">
                                Cancel
                            </v-btn>
                            <v-btn type="submit" :loading="productcreateloading" color="primary">
                                Submit
                                <span slot="loader" class="custom-loader">
                        <v-progress-circular indeterminate color="green"></v-progress-circular>
                       </span>
                            </v-btn>
                        </v-col>
                        </v-container>
                    </form>

                </v-card-text>
            </v-card>
          </div>
        </v-dialog>
        <v-dialog v-model="producteditdialog" max-width="750px" persistent v-if="producteditdialog">
            <v-card>
                <v-card-title>
                    <span class="headline">Edit your {{editoriginalname}}</span>
                </v-card-title>
                <v-card-text>
                    <form @submit.prevent="SubmitProductChanges">
                        <v-row >
                            <v-col cols="12">
                                <v-text-field
                                        name="productname"
                                        label="Name of the product"
                                        id="productname"
                                        required
                                        v-model="producttoedit.name"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row >
                            <v-col cols="12">
                                <v-text-field
                                        name="price"
                                        label="Product Price*"
                                        hint="4.99, 125.00, etc."
                                        id="price"
                                        required
                                        v-model="producttoedit.price"
                                        prefix="$"
                                        min="0"
                                        step=".01"
                                        type="number"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row >
                            <v-col cols="12">
                                <v-text-field
                                        name="units"
                                        label="Product Units*"
                                        hint="How many units are you selling for the selected price? ie. per lb, per 100 seeds, per 10 kg, each etc."
                                        id="units"
                                        required
                                        v-model="producttoedit.price_units"
                                        prefix="per"
                                ></v-text-field>
                            </v-col>
                        </v-row>

                        <v-col cols="12">
                            <v-text-field
                                    name="inventory"
                                    label="Inventory"
                                    hint="How many do you have in stock?"
                                    id="inventory"
                                    v-model="producttoedit.inventory"
                                    min="0"
                                    type="number"
                                    default="0"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                        <v-radio-group v-model="producttoedit.currently_have">
                            <v-radio
                                    label="I still have this Product"
                                    :value="true"
                                    color="primary"
                            >

                            </v-radio>
                            <v-radio
                                    label="I no longer have this Product, or it's out of stock"
                                    :value="false"
                                    color="primary"
                            >

                            </v-radio>
                        </v-radio-group>
                        </v-col>

                        <v-col cols="4" offset="5">
                            <v-btn @click="CloseEditProductDialog">
                                Cancel
                            </v-btn>
                            <v-btn type="submit" :loading="producteditloading" color="primary">
                                Submit
                                <span slot="loader" class="custom-loader">
                        <v-progress-circular indeterminate color="green"></v-progress-circular>
                       </span>
                            </v-btn>
                        </v-col>
                    </form>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog v-model="productdeletedialog"
                  max-width="750"
        >
                      <v-card>
                        <v-card-title
                                class="headline"
                                primary-title
                                style="justify-content: center"
                        >
                            Delete this?
                        </v-card-title>
                      <v-card-text>

                            By clicking 'Delete', you will be forever deleting ' {{producttodelete.name}} '.
                            Are you sure this is what you want to do? If not, hit Cancel, or click outside this box.
                      </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                            <v-btn
                                    color="red darken-1"
                                    :loading="productdeleteloading"
                                    :disabled="productdeleteloading"
                                    @click="ProductDeactivate"
                                    dark
                            >
                                Delete
                                <span slot="loader" class="custom-loader">
                        <v-progress-circular indeterminate color="green"></v-progress-circular>
                       </span>
                            </v-btn>
                            <v-btn
                                    color="primary"
                                    dark
                                    @click="productdeletedialog = false"
                            >
                                Cancel
                            </v-btn>
                        </v-card-actions>
                      </v-card>
        </v-dialog>
        <v-container>
            <v-data-table
                    :headers="productheaders"
                    sort-by="name"
                    :items="products"
                    class="elevation-1"
                    :loading="areproductsloading"
                    :search="searchvalue"
                    :footer-props="{
                    itemsPerPageOptions: [5, 10, 25, -1]}"
            >
              <template v-slot:top>
                <v-toolbar flat color="white">
                  <v-toolbar-title>Products</v-toolbar-title>
                  <v-divider
                    class="mx-4"
                    inset
                    vertical
                  ></v-divider>
                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="searchvalue"
                    append-icon="mdi-magnify"
                    label="Search"
                    single-line
                    hide-details
                  ></v-text-field>
                </v-toolbar>
              </template>
                <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
              <template v-slot:item.price="{ item }">
                <span>$ {{ item.price.slice(0, -2) }}</span>
              </template>
              <template v-slot:item.price_units="{ item }">
                <span>per {{ item.price_units }}</span>
              </template>
              <template v-slot:item.edit_delete="{ item }">
                <v-icon
                  small
                  class="mr-2"
                  @click="EditProductDialog(item)"
                >
                  mdi-pencil
                </v-icon>
                <v-icon
                  small
                  @click="DeleteProductDialog(item)"
                >
                  mdi-delete
                </v-icon>
              </template>
              <template v-slot:item.currently_have="{ item }">
                <v-checkbox
                  v-model="item.currently_have"
                  color="primary"
                  hide-details
                  disabled
                ></v-checkbox>
              </template>
              <template v-slot:item.complete_edit="{ item }">
                <router-link :to="'/forms/products/edit/' + item.slug" class="-li">
                  <v-icon
                    small
                  >
                    mdi-exit-to-app
                  </v-icon>
                </router-link>
              </template>
              <template v-slot:item.duplicate="{ item }">
                <v-icon
                  small
                  @click="DuplicateProductDialog(item)"
                >
                  mdi-content-copy
                </v-icon>
              </template>
                <template slot="no-data">
                    <v-alert :value="!areproductsloading" color="secondary">
                        Sorry, you have no products to show here. If you have some we don't know about, go ahead and press the green button on the bottom right to create one now!
                    </v-alert>
                </template>
            </v-data-table>

            <v-btn
                    dark
                    fab
                    bottom
                    right
                    fixed
                    color="green"
                    @click="StartQuickCreateProductDialog"
            >
                <v-icon>mdi-plus</v-icon>
            </v-btn>
        </v-container>
    </v-main>
</template>

<script>
import axios from 'axios';
import { validationMixin } from 'vuelidate';

export default {
  name: 'MyProducts',
  mixins: [validationMixin],
  data: () => ({
    products: [],
    errors: [],
    areproductsloading: false,

    productquickcreatedialog: false,
    simplestquickcreate: true,
    productcreateloading: false,
    newproduct: {
      name: '',
      price: 0.00,
      price_units: '',
      inventory: '',
      crop: [],
      component: [],
    },
    newproduct_images: [],


    usersdefaults: [],
    usersdefaultsfetched: false,

    availablevarietycomponents: [],


    preexistingcrop: true,

    varietyitems: [],
    arecropsorvarietiesloading: false,
    varietieshavebeenfetched: false,

    selectedvariety: [],

    cropitems: [],
    cropshavebeenfetched: false,
    nocropalert: false,

    arevarietycomponentsloading: false,

    producteditdialog: false,
    producteditloading: false,

    producttoedit: [],

    productdetails: [],


    editoriginalname: '',


    productdeletedialog: false,
    productdeleteloading: false,
    producttodelete: [],


    productheaders: [
      {
        text: 'Name',
        align: 'left',
        sortable: true,
        value: 'name',
      },
      { text: 'Price', value: 'price', sortable: true },
      { text: 'Units', value: 'price_units', sortable: true },
      { text: 'Inventory', value: 'inventory', sortable: true },
      { text: 'Currently Have', value: 'currently_have', sortable: true },
      { text: 'Quick Edit/Delete', value: 'edit_delete', sortable: false },
      { text: 'Full Edit', value: 'complete_edit', sortable: false },
      { text: 'Duplicate', value: 'duplicate', sortable: false },
    ],

    searchvalue: '',
  }),

  methods: {
    GetThisUsersProducts() {
      this.areproductsloading = true;
      const authheader = `Token ${this.$store.getters.token}`;
      return axios.get('basics/table/product/by/vendor/',

        {
          headers: {
            Authorization: authheader,
          },
        })
        .then((response) => {
          this.products = response.data;
        })
        .then(() => {
          this.areproductsloading = false;
        });
    },

    StartQuickCreateProductDialog() {
      this.productquickcreatedialog = true;
      /* if (!this.cropshavebeenfetched) {
        this.GetUsersCrops();
      } */
    },
    CancelQuickCreateProductDialog() {
      this.productquickcreatedialog = false;
      this.newproduct = {};
      this.preexistingcrop = true;
    },

    // Before anything else, fetches this users saved defaults.
    GetUserSavedDefaults() {
      const authheader = `Token ${this.$store.getters.token}`;

      if (!this.usersdefaultsfetched) {
        return axios.get('profile/saveddefaults/',
          {
            headers: {
              Authorization: authheader,
            },
          })
          .then((response) => {
            this.usersdefaults = response.data;
            this.usersdefaultsfetched = true;
          });
      }
      return Promise.resolve();
    },


    // Creates a Crop if a variety was selected instead of a crop, otherwise it just continues
    QuickCreateCrop() {
      const authheader = `Token ${this.$store.getters.token}`;

      if (!this.preexistingcrop) {
        return axios.post('baseproduct/create/', {
          variety: this.selectedvariety.id,
          producer: this.$store.state.user.pk,
          growing_location: this.usersdefaults.default_growing_location,
          growing_information: this.usersdefaults.default_growing_information,
        },
        {
          headers: {
            Authorization: authheader,
          },
        })
          .then((response) => {
            this.newproduct.crop = response.data;
            this.cropshavebeenfetched = false;
            this.selectedvariety = [];
          });
      }
      return Promise.resolve();
    },

    GetProductData() {
      if (this.newproduct.component) {
        return this.removeEmptyStrings({
          parent_product: this.newproduct.crop.id,
          component: this.newproduct.component.id,
          name: this.newproduct.name,
          price: this.newproduct.price,
          price_units: this.newproduct.price_units,
          inventory: this.newproduct.inventory,
          shipping_location: this.usersdefaults.default_shipping_location,
        });
      } return this.removeEmptyStrings({
        name: this.newproduct.name,
        price: this.newproduct.price,
        price_units: this.newproduct.price_units,
        inventory: this.newproduct.inventory,
        shipping_location: this.usersdefaults.default_shipping_location,
      });
    },

    QuickCreateProduct() {
      this.productcreateloading = true;
      return this.GetUserSavedDefaults()
        .then(() => this.QuickCreateCrop())
        .then(() => {
          const authheader = `Token ${this.$store.getters.token}`;
          return axios.post('forms/create/product/', this.GetProductData(),
            {
              headers: {
                Authorization: authheader,
              },
            })
            .then((response) => {
              this.ProductImageUpload(response.data.id);
              this.$parent.$emit('alert-emitted', {
                alert_icon: 'mdi-check-circle',
                alert_color: 'success',
                alert_message: `Your product " ${response.data.name} " was successfully created!`,
                alert_model: true,
              });
            })
            .then(() => {
              this.GetThisUsersProducts();
              this.productcreateloading = false;
              this.productquickcreatedialog = false;
              this.availablevarietycomponents = [];
              this.newproduct = {
                name: '',
                price: 0.00,
                price_units: '',
                inventory: '',
                crop: [],
                component: [],
              };
              this.preexistingcrop = true;
            })

            .catch(() => {
              this.$parent.$emit('alert-emitted', {
                alert_icon: 'mdi-emoticon-frown-outline', alert_color: 'error', alert_message: 'Something broke. Sorry :( ', alert_model: true,
              });
            });
        });
    },
    // I'd rather have this sent as a single request with all the images, but I'll wait to refactor that for now.
    ProductImageUpload(product) {
      this.productimagesubmitloading = true;
      const authheader = `Token ${this.$store.getters.token}`;
      this.newproduct_images.forEach((image) => {
        const formData = new FormData();
        formData.append('image', image, image.name);
        formData.append('product', product);
        return axios.post('image/product/create/', formData,
          {
            headers: {
              Authorization: authheader,
            },
          })
          .then(() => {
            this.$parent.$emit('alert-emitted', {
              alert_icon: 'mdi-check-circle', alert_color: 'success', alert_message: `Product Image " ${image.name} "  successfully uploaded!`, alert_model: true,
            });
            this.productimagesubmitloading = false;
          })
          .catch(() => {
            this.$parent.$emit('alert-emitted', {
              alert_icon: 'mdi-emoticon-frown-outline', alert_color: 'error', alert_message: 'Something broke with the image upload. Sorry :( ', alert_model: true,
            });
          });
      });
    },
    /* GetUsersCrops() {
      this.arecropsorvarietiesloading = true;
      this.cropitems = [];
      const authheader = `Token ${this.$store.getters.token}`;

      axios.get(`barebones/baseproduct/by/producer/${userid}/`,
        {
          headers: {
            Authorization: authheader,
          },
        })
        .then((response) => {
          this.cropitems = response.data;
        })
        .then(() => {
          this.arecropsorvarietiesloading = false;
        })
        .then(() => {
          if (this.cropitems.length === 0) {
            this.GetAllVarieties();
            this.nocropalert = true;
          }
        })
        .then(() => {
          this.cropshavebeenfetched = true;
        });
    }, */

    GetCropDetails() {
      const croptolookupslug = this.newproduct.crop.slug;
      this.selectedcropdetails = [];
      return axios.get(`/allbaseproducts/${croptolookupslug}/`)
        .then((response) => {
          this.selectedcropdetails = response.data;
        });
    },
    GetProductDetails(slug) {
      return axios.get(`/allproducts/${slug}/`)
        .then((response) => {
          this.productdetails = response.data;
        });
    },
    GetAvailableVarietyComponentsFromCrop() {
      this.newproduct.component = '';
      this.GetCropDetails()
        .then(() => {
          this.arevarietycomponentsloading = true;
          this.availablevarietycomponents = [];
        })
        .then(() => {
          const varietytocheck = this.selectedcropdetails.variety.id;
          return axios.get(`barebones/filtered/component/by/variety/${varietytocheck}/`);
        })

        .then((response) => {
          this.availablevarietycomponents = response.data;
        })
        .then(() => {
          this.arevarietycomponentsloading = false;
        });
    },
    GetAllVarieties() {
      this.preexistingcrop = false;
      this.availablevarietycomponents = [];
      this.newproduct.component = '';
      this.selectedvariety = [];
      if (!this.varietieshavebeenfetched) {
        this.arecropsorvarietiesloading = true;
        return axios.get('barebones/list/varieties/')
          .then((response) => {
            this.varietyitems = response.data;
            this.varietieshavebeenfetched = true;
          })
          .then(() => {
            this.arecropsorvarietiesloading = false;
          });
      } return {};
    },


    GetAvailableVarietyComponentsFromVariety() {
      this.arevarietycomponentsloading = true;
      this.availablevarietycomponents = [];
      this.newproduct.component = '';
      const varietytocheck = this.selectedvariety.id;
      return axios.get(`barebones/filtered/component/by/variety/${varietytocheck}/`)
        .then((response) => {
          this.availablevarietycomponents = response.data;
        })
        .then(() => {
          this.arevarietycomponentsloading = false;
        });
    },

    SwitchBackToCrop() {
      this.preexistingcrop = true;
      this.availablevarietycomponents = [];
      this.newproduct.component = '';
      this.newproduct.crop = [];
    },


    EditProductDialog(item) {
      this.producteditdialog = true;
      this.producttoedit = Object.assign({}, item);
      this.producttoedit.price = item.price.slice(0, -2);
      this.editoriginalname = item.name;
    },
    CloseEditProductDialog() {
      this.producteditdialog = false;
      this.producttoedit = [];
      this.editoriginalname = '';
    },
    DeleteProductDialog(item) {
      this.productdeletedialog = true;
      this.producttodelete = item;
    },


    DuplicateProductDialog(item) {
      this.newproduct = Object.assign({}, item);
      this.newproduct.price = item.price.slice(0, -2);
      this.preexistingcrop = true;
      this.productquickcreatedialog = true;
    },

    SubmitProductChanges() {
      const authheader = `Token ${this.$store.getters.token}`;
      const productdata = this.removeEmptyStrings({
        name: this.producttoedit.name,
        currently_have: this.producttoedit.currently_have,
        price: this.producttoedit.price,
        price_units: this.producttoedit.price_units,
        inventory: this.producttoedit.inventory,
      });
      return axios.patch(`forms/edit/products/update/${this.producttoedit.id}`, productdata,

        {
          headers: {
            Authorization: authheader,
          },
        })
        .then(() => {
          if (!this.$store.getters.error) {
            this.$parent.$emit('alert-emitted', { alert_icon: 'check_circle', alert_color: 'success', alert_message: 'Product Updated!' });
          }
        })
        .then(() => {
          if (!this.$store.getters.error) {
            this.CloseEditProductDialog();
          }
        })
        .then(() => {
          if (!this.$store.getters.error) {
            this.GetThisUsersProducts();
          }
        })
        .catch(() => {
        });
    },

    ProductDeactivate() {
      this.productdeleteloading = true;
      const authheader = `Token ${this.$store.getters.token}`;
      const productid = this.producttodelete.id;
      return axios.patch(`forms/edit/products/update/${productid}`, {
        is_active: false,
      },
      {
        headers: {
          Authorization: authheader,
        },
      })
        .then(() => {
          if (!this.$store.getters.error) {
            this.productdeleteloading = false;
            this.productdeletedialog = false;
          }
        })
        .then(() => {
          if (!this.$store.getters.error) {
            this.$parent.$emit('alert-emitted', { alert_icon: 'check_circle', alert_color: 'success', alert_message: 'Product Deleted' });
            this.GetThisUsersProducts();
          }
        })
        .catch(() => {
        });
    },

    removeEmptyStrings(obj) {
      const newObj = {};
      Object.keys(obj).forEach((prop) => {
        if (obj[prop] !== '') { newObj[prop] = obj[prop]; }
      });
      return newObj;
    },
  },

  created() {
    this.GetThisUsersProducts();
  },

  computed: {
  },
  // eslint-disable-next-line max-len
  // TODO Need to change the product creation, so users can select if they're adding a product they produce themselves, or selling a product produced by someone else.

};
</script>

<style scoped>

</style>
